import http from "./httpService";
import { getCurrentUserId, getJwt } from './authService';
//import config from "../config.json";

const apiEndpoint = `api/register_inactive`;

export async function register(user) {
    const affiliateId = localStorage.getItem("affiliateId");

    const response = await http.post(apiEndpoint, {
        email: user.email,
        password: user.password,
        ...(affiliateId && { affiliate_id: affiliateId })
    }, {headers: {authorization: getJwt()}});

    // console.log("register in userService", response);
    if(response.data.error)
    {
        return response.data;
    }
    await localStorage.setItem('user_id', response.data.id);
    await localStorage.setItem('email', response.data.email);
    await localStorage.removeItem('affiliateId');
    // console.log('serService: ', localStorage.getItem('email'))

    return response;
}

export async function activation_code(code) {
    const user_id = getCurrentUserId();
    const response = await http.get('/activation_code/' + user_id + '/' + code, {headers: {authorization: getJwt()}});

    //console.log("register in userService", response);
    if(response.data.error)
    {
        return response.data;
    }

    return response;
}




